import { DateTime, Duration, Interval } from "luxon";
import { _throw, IllegalStateError } from "shared-ts-utils-core";
import { DurationUnit } from "luxon";
import { DiffOptions, DurationLike } from "luxon";

export class IntervalUtils {
  static fromDateTimes(
    start: DateTime<true>,
    end: DateTime<true>
  ): Interval<true> {
    return (Interval.fromDateTimes(start, end) ??
      _throw(
        new IllegalStateError(`Invalid Interval: [${start}, ${end}]`)
      )) as Interval<true>;
  }

  static before(end: DateTime<true>, duration: DurationLike): Interval<true> {
    return (Interval.before(end, duration) ??
      _throw(
        new IllegalStateError(`Invalid Interval: [${duration} -> ${end}]`)
      )) as Interval<true>;
  }

  static toValidDurationOrUndef(
    interval: Interval,
    unit?: DurationUnit | DurationUnit[],
    opts?: DiffOptions
  ): Duration<true> | undefined {
    if (!interval.isValid) {
      return undefined;
    }
    const duration = interval.toDuration(unit, opts);
    if (!duration.isValid) {
      return undefined;
    }
    return duration;
  }

  static fromDateTimesOrUndef(
    start: DateTime,
    end: DateTime
  ): Interval<true> | undefined {
    const interval = Interval.fromDateTimes(start, end);
    if (interval.isValid) {
      return interval;
    }
    return undefined;
  }
}
